import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function ClientFields({ values, onChange, disabled = false }) {
  const set = (k, v) => onChange({ ...values, [k]: v });
  return (
    <div className="surface p-6 space-y-4" data-testid="client-fields">
      <div className="heading text-lg font-semibold">Dane zlecenia</div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-1.5">
          <Label htmlFor="name">Nazwa zlecenia *</Label>
          <Input
            id="name"
            data-testid="field-name"
            value={values.name || ""}
            disabled={disabled}
            placeholder="np. Kuchnia Nowak"
            onChange={(e) => set("name", e.target.value)}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="client_name">Klient (imię / firma)</Label>
          <Input
            id="client_name"
            data-testid="field-client-name"
            value={values.client_name || ""}
            disabled={disabled}
            placeholder="np. Jan Kowalski"
            onChange={(e) => set("client_name", e.target.value)}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="client_phone">Telefon</Label>
          <Input
            id="client_phone"
            data-testid="field-client-phone"
            value={values.client_phone || ""}
            disabled={disabled}
            placeholder="np. 600 100 200"
            onChange={(e) => set("client_phone", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
